export const SKIP_CLICK_OUTSIDE = Symbol('SKIP_CLICK_OUTSIDE')

export type ExtendedEvent<T extends Event> = T & {
  [SKIP_CLICK_OUTSIDE]?: boolean
}
